import { getInitialsFromNames } from 'n2p-ui-library';

export const getInitialsFromString = (value: string, type?: string): string => {
	if (type !== undefined && type.indexOf('category') !== -1) {
		return getInitialsFromNames(value[0]);
	}

	return getInitialsFromNames(value);
};
